export default __webpack_public_path__ + "a6869c9.png";